import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';

export const logo = 'https://cdn.discordapp.com/attachments/884837200179646528/1120773265942642911/ezgif.com-crop.gif';

export const categories = [
  { name: 'Trending', icon: <HomeIcon />, },
  { name: 'AteGGz', icon: <SportsEsportsIcon />, },
  { name: 'Learn Programming', icon: <CodeIcon />, },
  { name: 'Music', icon: <MusicNoteIcon /> },
  { name: 'Podcast', icon: <GraphicEqIcon />, },
  { name: 'Movie', icon: <OndemandVideoIcon />, },
  { name: 'Gaming', icon: <SportsEsportsIcon />, },
  { name: 'Live', icon: <LiveTvIcon />, },
  { name: 'Sport', icon: <FitnessCenterIcon />, },
  { name: 'Fashion', icon: <CheckroomIcon />, },
  { name: 'Gym', icon: <FitnessCenterIcon />, },
];

export const demoThumbnailUrl = '';
export const demoChannelUrl = '';
export const demoVideoUrl = '';
export const demoChannelTitle = '';
export const demoVideoTitle = '';
export const demoProfilePicture = ''